<template>
  <b-modal id="approval"  centered hide-footer
  @hidden="closeModal"
  >
    <div class="d-flex">
      <div class="warning-wrap">
        <i class="fa fa-triangle-exclamation" />
      </div>
     <div>
        <h6 class="">Are you sure you want to <b>Approve</b> the selected pending item?</h6>
        <p class="light-txt">
          This action is permanent and cannot be undone. If you're sure, please confirm your decision.
        </p>
      </div>
    </div>
    <div class="d-flex justify-content-end flex-column-reverse flex-sm-row mt-3 gap-2">
      <b-button variant="secondary" @click="closeModal">Close</b-button>
      <b-button variant="primary" class="univ-btn m-0 px-5 univ-approve" @click="submit"
        >Approve  </b-button
      >
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "Approve",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$bvModal.show('approval');
      } else {
        this.$bvModal.hide('approval');
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
      this.$bvModal.hide('approval');
    },
    submit() {
      this.$emit('submit');
    },
  },
};
</script>
<style>
.univ-approve{
  width: fit-content;
}
.warning-wrap{
    background: rgb(242, 242, 217);
      border-radius: 50px;
  height: fit-content;
  padding: 0.7rem 0.8rem;
  margin-right: 1rem;
}
.warning-wrap i {
  color: #dc8d07;
  font-size: 18px;
}
@media (max-width:576px) {
  .univ-approve{
    width: 100%;
    max-width: none;
  }
}
</style>